import React, { useState, useEffect, useRef } from 'react';
import MenuIcon from '@mui/icons-material/Menu';
import { Box, Fade } from "@mui/material";
import AddIcon from '@mui/icons-material/Add';
import { Link } from 'react-router-dom';
import AlbumIcon from '@mui/icons-material/Album';
import './sidebarai.css';
import { useAuth } from '../../context/AuthContext';
import UserProfile from '../../components/profile/UserProfile';
import CloseIcon from '@mui/icons-material/Close';

function Sidebarai() {
    const [extend, setExtend] = useState(false);
    const [isMobile, setIsMobile] = useState(window.innerWidth <= 600);
    const [isTablet, setIsTablet] = useState(window.innerWidth <= 768 && window.innerWidth > 600);
    const [sidebarOpen, setSidebarOpen] = useState(false);
    const { currentUser } = useAuth();
    const sidebarRef = useRef(null);

    useEffect(() => {
        const handleResize = () => {
            const width = window.innerWidth;
            setIsMobile(width <= 600);
            setIsTablet(width <= 768 && width > 600);
            
            if (width > 600) {
                setSidebarOpen(false);
                document.body.classList.remove('sidebar-open');
            }
        };

        const handleClickOutside = (event) => {
            if (sidebarOpen && sidebarRef.current && !sidebarRef.current.contains(event.target)) {
                // Check if the click was on the mobile toggle button
                const toggleButton = document.querySelector('.mobile-menu-toggle');
                if (toggleButton && !toggleButton.contains(event.target)) {
                    toggleSidebar();
                }
            }
        };

        const handleToggleSidebar = () => {
            setSidebarOpen(prev => !prev);
            if (sidebarOpen) {
                document.body.classList.remove('sidebar-open');
            } else {
                document.body.classList.add('sidebar-open');
            }
        };

        window.addEventListener('resize', handleResize);
        window.addEventListener('toggleSidebar', handleToggleSidebar);
        document.addEventListener('mousedown', handleClickOutside);
        
        return () => {
            window.removeEventListener('resize', handleResize);
            window.removeEventListener('toggleSidebar', handleToggleSidebar);
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [sidebarOpen]);

    const toggleSidebar = () => {
        setSidebarOpen(prev => !prev);
        if (!sidebarOpen) {
            document.body.classList.add('sidebar-open');
        } else {
            document.body.classList.remove('sidebar-open');
        }
    };

    return (
        <>
            <Fade in={isMobile}>
                <Box className="mobile-menu-toggle" onClick={toggleSidebar}>
                    {sidebarOpen ? <CloseIcon /> : <MenuIcon />}
                </Box>
            </Fade>
            
            <Box 
                ref={sidebarRef}
                className={`sidebar ${sidebarOpen ? 'open' : ''}`}
            >
                <Box 
                    id="menu" 
                    onClick={isMobile || isTablet ? toggleSidebar : () => setExtend(!extend)}
                >
                    {sidebarOpen && isMobile ? <CloseIcon /> : <MenuIcon />}
                </Box>

                <Link 
                    to='/' 
                    className='sidebar-menu-item'
                    onClick={() => {
                        if (isMobile) {
                            setSidebarOpen(false);
                            document.body.classList.remove('sidebar-open');
                        }
                    }}
                >
                    <AddIcon />
                    {(extend || !isTablet || (isMobile && sidebarOpen)) && <p>New Chat</p>}
                </Link>

                <Link 
                    to='/Aivoice' 
                    className='sidebar-menu-item'
                    onClick={() => {
                        if (isMobile) {
                            setSidebarOpen(false);
                            document.body.classList.remove('sidebar-open');
                        }
                    }}
                >
                    <AlbumIcon />
                    {(extend || !isTablet || (isMobile && sidebarOpen)) && <p>AI Voice</p>}
                </Link>

                {currentUser && (
                    <Box className="sidebar-profile">
                        <UserProfile extend={extend || !isTablet || (isMobile && sidebarOpen)} />
                    </Box>
                )}
            </Box>
        </>
    );
}

export default Sidebarai;
